// import { useEffect, useState } from "react";
// import { db } from "../firebase/firebase";
// import {
//     collection,
//     getDocs,
//     query,
//     orderBy,
// } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";

// export default function Students() {
//     const [students, setStudents] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchStudents = async () => {
//             try {
//                 const q = query(
//                     collection(db, "students"),
//                     orderBy("createdAt", "desc")
//                 );

//                 const snapshot = await getDocs(q);

//                 const list = snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     ...doc.data(),
//                 }));

//                 setStudents(list);
//             } catch (err) {
//                 console.error("Error fetching students:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchStudents();
//     }, []);

//     return (
//         <div className="min-h-screen px-6 py-8 text-white">

//             {/* Header */}
//             <div className="flex justify-between items-center mb-6">
//                 <h1 className="text-3xl font-bold text-orange-500">
//                     Student Registrations
//                 </h1>

//                 <button
//                     onClick={() => navigate("/dashboard/add-student")}
//                     className="bg-orange-500 px-4 py-2 rounded hover:bg-orange-600"
//                 >
//                     + Add Student
//                 </button>
//             </div>

//             {/* Content */}
//             {loading ? (
//                 <p className="text-gray-300">Loading students...</p>
//             ) : students.length === 0 ? (
//                 <p className="text-gray-400">No registrations yet.</p>
//             ) : (
//                 <div className="bg-white/10 backdrop-blur-xl rounded-xl border border-white/10 overflow-x-auto">
//                     <table className="min-w-full text-sm text-left text-gray-300">

//                         <thead className="text-xs uppercase bg-white/5 text-gray-400">
//                             <tr>
//                                 <th className="px-4 py-3">Name</th>
//                                 <th className="px-4 py-3">Mobile</th>
//                                 <th className="px-4 py-3">Course</th>
//                                 <th className="px-4 py-3">Qualification</th>
//                                 <th className="px-4 py-3">Status</th>
//                                 <th className="px-4 py-3">Date</th>
//                                 <th className="px-4 py-3">Action</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {students.map((s) => (
//                                 <tr
//                                     key={s.id}
//                                     className="border-b border-white/10 hover:bg-white/5"
//                                 >
//                                     <td className="px-4 py-3 font-medium text-white">
//                                         {s.fullName}
//                                     </td>

//                                     <td className="px-4 py-3">{s.mobile}</td>

//                                     <td className="px-4 py-3">{s.course || "-"}</td>

//                                     <td className="px-4 py-3">{s.educationType || "-"}</td>

//                                     <td className="px-4 py-3">
//                                         <StatusBadge status={s.status} />
//                                     </td>

//                                     <td className="px-4 py-3">
//                                         {s.createdAt?.toDate
//                                             ? s.createdAt.toDate().toLocaleDateString()
//                                             : "-"}
//                                     </td>

//                                     <td className="px-4 py-3">
//                                         <button
//                                             onClick={() =>
//                                                 navigate(`/dashboard/student-details?id=${s.id}`)
//                                             }
//                                             className="text-orange-400 hover:underline"
//                                         >
//                                             View
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>

//                     </table>
//                 </div>
//             )}
//         </div>
//     );
// }

// /* ---------------- STATUS BADGE ---------------- */
// function StatusBadge({ status }) {
//     const map = {
//         new: "bg-blue-500/20 text-blue-400",
//         approved: "bg-green-500/20 text-green-400",
//         rejected: "bg-red-500/20 text-red-400",
//     };

//     return (
//         <span
//             className={`px-2 py-1 rounded text-xs font-semibold ${map[status] || "bg-gray-500/20 text-gray-300"
//                 }`}
//         >
//             {status || "new"}
//         </span>
//     );
// }


import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import {
    collection,
    getDocs,
    query,
    orderBy,
    deleteDoc,
    doc
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function Students() {
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");
    const [courseFilter, setCourseFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("admitted"); // default

    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudents = async () => {
            try {
                const q = query(
                    collection(db, "students"),
                    orderBy("createdAt", "desc")
                );

                const snapshot = await getDocs(q);

                const list = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setStudents(list);
            } catch (err) {
                console.error("Error fetching students:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchStudents();
    }, []);

    /* ---------------- FILTER LOGIC ---------------- */
    useEffect(() => {
        let data = [...students];

        // Status filter
        if (statusFilter) {
            data = data.filter(s => (s.status || "new") === statusFilter);
        }

        // Course filter
        if (courseFilter) {
            data = data.filter(s => s.course === courseFilter);
        }

        // Search
        if (search) {
            data = data.filter(s =>
                s.fullName?.toLowerCase().includes(search.toLowerCase()) ||
                s.mobile?.includes(search)
            );
        }

        setFilteredStudents(data);
    }, [students, search, courseFilter, statusFilter]);

    /* ---------------- DELETE ---------------- */
    const handleDelete = async (id) => {
        const password = prompt("Enter admin password to delete:");

        if (password !== "admin123") {
            alert("Wrong password!");
            return;
        }

        const confirmDelete = window.confirm("Are you sure?");
        if (!confirmDelete) return;

        try {
            await deleteDoc(doc(db, "students", id));
            setStudents(prev => prev.filter(s => s.id !== id));
            alert("Deleted successfully");
        } catch (err) {
            console.error(err);
            alert("Error deleting student");
        }
    };

    return (
        <div className="min-h-screen px-6 py-8 text-white">

            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold text-orange-500">
                    Student Registrations
                </h1>

                <button
                    onClick={() => navigate("/dashboard/add-student")}
                    className="bg-orange-500 px-4 py-2 rounded hover:bg-orange-600"
                >
                    + Add Student
                </button>
            </div>

            {/* Filters */}
            <div className="flex flex-wrap gap-3 mb-4">

                {/* Search */}
                <input
                    type="text"
                    placeholder="Search name or mobile..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="px-3 py-2 rounded bg-white/10 border border-white/10 text-white"
                />

                {/* Course Filter */}
                <select
                    value={courseFilter}
                    onChange={(e) => setCourseFilter(e.target.value)}
                    className="px-3 py-2 rounded bg-white/50 border border-white/10 text-black"
                >
                    <option value="">All Courses</option>
                    {[...new Set(students.map(s => s.course).filter(Boolean))].map((c, i) => (
                        <option key={i} value={c}>{c}</option>
                    ))}
                </select>

                {/* Status Filter */}
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="px-3 py-2 rounded bg-white/50 border border-white/10 text-black"
                >
                    <option value="admitted">Admitted</option>
                    <option value="new">New</option>
                    {/* <option value="approved">Approved</option> */}
                    {/* <option value="rejected">Rejected</option> */}
                </select>

            </div>

            {/* Content */}
            {loading ? (
                <p className="text-gray-300">Loading students...</p>
            ) : filteredStudents.length === 0 ? (
                <p className="text-gray-400">No students found.</p>
            ) : (
                <div className="bg-white/10 backdrop-blur-xl rounded-xl border border-white/10 overflow-x-auto">
                    <table className="min-w-full text-sm text-left text-gray-300">

                        <thead className="text-xs uppercase bg-white/5 text-gray-400">
                            <tr>
                                <th className="px-4 py-3">Name</th>
                                <th className="px-4 py-3">Mobile</th>
                                <th className="px-4 py-3">Course</th>
                                <th className="px-4 py-3">Qualification</th>
                                <th className="px-4 py-3">Status</th>
                                <th className="px-4 py-3">Date</th>
                                <th className="px-4 py-3">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredStudents.map((s) => (
                                <tr
                                    key={s.id}
                                    className="border-b border-white/10 hover:bg-white/5"
                                >
                                    <td className="px-4 py-3 font-medium text-white">
                                        {s.fullName}
                                    </td>

                                    <td className="px-4 py-3">{s.mobile}</td>

                                    <td className="px-4 py-3">{s.course || "-"}</td>

                                    <td className="px-4 py-3">{s.educationType || "-"}</td>

                                    <td className="px-4 py-3">
                                        <StatusBadge status={s.status} />
                                    </td>

                                    <td className="px-4 py-3">
                                        {s.createdAt?.toDate
                                            ? s.createdAt.toDate().toLocaleDateString()
                                            : "-"}
                                    </td>

                                    <td className="px-4 py-3 flex gap-3">
                                        <button
                                            onClick={() =>
                                                navigate(`/dashboard/student-details?id=${s.id}`)
                                            }
                                            className="text-orange-400 hover:underline"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() => handleDelete(s.id)}
                                            className="text-red-400 hover:underline"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            )}
        </div>
    );
}

/* ---------------- STATUS BADGE ---------------- */
function StatusBadge({ status }) {
    const map = {
        new: "bg-blue-500/20 text-blue-400",
        approved: "bg-green-500/20 text-green-400",
        rejected: "bg-red-500/20 text-red-400",
        admitted: "bg-purple-500/20 text-purple-400", // added
    };

    return (
        <span
            className={`px-2 py-1 rounded text-xs font-semibold ${map[status] || "bg-gray-500/20 text-gray-300"
                }`}
        >
            {status || "new"}
        </span>
    );
}